import { Provider } from '@angular/core';

export const appProviders: Provider[] = [
	//Service1, Service2, Service3
]